module.exports = __webpack_public_path__ + "img/mute.fd3c1674.svg";